export default __webpack_public_path__ + "static/media/Trend2.d0e75994.svg";